import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Checkbox,
  Button,
  Box,
  IconButton,
  Typography,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

export default function MediaGallery({
  open,
  setOpen,
  images = [],
  videos = [],
  selectedItems,
  setSelectedItems,
  onRemoveImage,
  onRemoveVideo,
  peerId,
}) {

  const [uploading, setUploading] =
    React.useState(false);

  const [progress, setProgress] =
    React.useState(0);

  const [message, setMessage] =
    React.useState("");

  const toggle = (type, index) => {

    const key = `${type}-${index}`;

    setSelectedItems((prev) =>
      prev.includes(key)
        ? prev.filter((x) => x !== key)
        : [...prev, key]
    );
  };

  // =====================================================
  // UPLOAD
  // =====================================================

  const handleUpload = async () => {

    if (selectedItems.length === 0) {

      setMessage(
        "Please select at least one item"
      );

      return;
    }

    if (!peerId) {

      setMessage("❌ Missing AID");

      return;
    }

    setUploading(true);

    setProgress(0);

    setMessage("");

    try {

      const formData =
        new FormData();

      formData.append(
        "aid",
        peerId
      );

      const urlToFile = async (
        url,
        filename,
        mimeType
      ) => {

        const res =
          await fetch(url);

        const blob =
          await res.blob();

        return new File(
          [blob],
          filename,
          {
            type: mimeType
          }
        );
      };

      let hasImages = false;
      let hasVideos = false;

      for (const key of selectedItems) {

        const [type, index] =
          key.split("-");

        const i =
          Number(index);

        // IMAGE
        if (type === "image") {

          const file =
            await urlToFile(
              images[i],
              `image_${Date.now()}_${i}.jpg`,
              "image/jpeg"
            );

          formData.append(
            "images[]",
            file
          );

          hasImages = true;
        }

        // VIDEO
        else if (
          type === "video"
        ) {

          const res =
            await fetch(videos[i]);

          const blob =
            await res.blob();

          const file =
            new File(
              [blob],
              `video_${Date.now()}_${i}.webm`,
              {
                type:
                  blob.type ||
                  "video/webm",
              }
            );

          formData.append(
            "videos[]",
            file
          );

          hasVideos = true;
        }
      }

      if (hasImages) {
        formData.append(
          "hasImages",
          "1"
        );
      }

      if (hasVideos) {
        formData.append(
          "hasVideos",
          "1"
        );
      }

      const xhr =
        new XMLHttpRequest();

      xhr.open(
        "POST",
        "https://claimsmitra.com/livesurvey/upload_live_images"
      );

      xhr.upload.onprogress = (
        event
      ) => {

        if (
          event.lengthComputable
        ) {

          const percent =
            Math.round(
              (
                event.loaded /
                event.total
              ) * 100
            );

          setProgress(percent);
        }
      };

      xhr.onload = () => {

        setUploading(false);

        try {

          const res =
            JSON.parse(
              xhr.responseText
            );

          console.log(
            "Server Response:",
            res
          );

          if (
            res.status === 200
          ) {

            setMessage(
              "✅ Upload successful"
            );

            setSelectedItems([]);
          } else {

            setMessage(
              `❌ ${res.message || "Upload failed"}`
            );
          }

        } catch (e) {

          console.error(
            "Invalid JSON:",
            xhr.responseText
          );

          setMessage(
            "❌ Invalid server response"
          );
        }
      };

      xhr.onerror = () => {

        setUploading(false);

        setMessage(
          "❌ Upload error"
        );
      };

      xhr.send(formData);

    } catch (err) {

      console.error(err);

      setUploading(false);

      setMessage(
        "❌ Something went wrong"
      );
    }
  };

  return (

    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="md"
    >

      {/* TITLE */}
      <DialogTitle>
        Media Gallery
        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            fontWeight: 700,
          }}
        >
         {peerId || "No AID"}
        </Typography>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers>

        {/* ================================================= */}
        {/* IMAGES */}
        {/* ================================================= */}

        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            fontWeight: 700,
          }}
        >
          Images
        </Typography>

        <Grid
          container
          spacing={2}
          sx={{ mb: 4 }}
        >

          {images.length > 0 ? (

            images.map(
              (img, i) => (

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  key={`img-${i}`}
                >

                  <Box
                    sx={{
                      position:
                        "relative",

                      width: "100%",

                      borderRadius: 2,

                      overflow:
                        "hidden",

                      bgcolor:
                        "#000",

                      border:
                        "1px solid rgba(255,255,255,0.12)",
                    }}
                  >

                    {/* CHECKBOX */}
                    <Checkbox
                      checked={selectedItems.includes(
                        `image-${i}`
                      )}

                      onChange={() =>
                        toggle(
                          "image",
                          i
                        )
                      }

                      sx={{
                        position:
                          "absolute",

                        top: 4,
                        left: 4,

                        zIndex: 5,

                        color:
                          "#fff",

                        bgcolor:
                          "rgba(0,0,0,0.45)",

                        borderRadius:
                          "50%",

                        p: 0.5,

                        "&.Mui-checked":
                        {
                          color:
                            "#fff",
                        },
                      }}
                    />

                    {/* DELETE */}
                    <IconButton
                      onClick={() =>
                        onRemoveImage(
                          i
                        )
                      }

                      sx={{
                        position:
                          "absolute",

                        top: 4,
                        right: 4,

                        zIndex: 5,

                        color:
                          "#fff",

                        bgcolor:
                          "rgba(0,0,0,0.55)",

                        "&:hover":
                        {
                          bgcolor:
                            "rgba(0,0,0,0.75)",
                        },
                      }}
                    >
                      <DeleteIcon
                        fontSize="small"
                      />
                    </IconButton>

                    {/* IMAGE */}
                    <Box
                      component="img"
                      src={img}
                      alt={`image-${i}`}
                      sx={{
                        width: "100%",

                        height: 180,

                        objectFit:
                          "cover",

                        display:
                          "block",
                      }}
                    />
                  </Box>
                </Grid>
              )
            )

          ) : (

            <Grid item xs={12}>
              <Typography
                variant="caption"
              >
                No images
              </Typography>
            </Grid>
          )}
        </Grid>

        {/* ================================================= */}
        {/* VIDEOS */}
        {/* ================================================= */}

        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            fontWeight: 700,
          }}
        >
          Videos
        </Typography>

        <Grid
          container
          spacing={2}
        >

          {videos.length > 0 ? (

            videos.map(
              (vid, i) => (

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  key={`vid-${i}`}
                >

                  <Box
                    sx={{
                      position:
                        "relative",

                      width: "100%",

                      borderRadius: 2,

                      overflow:
                        "hidden",

                      bgcolor:
                        "#000",

                      border:
                        "1px solid rgba(255,255,255,0.12)",
                    }}
                  >

                    {/* CHECKBOX */}
                    <Checkbox
                      checked={selectedItems.includes(
                        `video-${i}`
                      )}

                      onChange={() =>
                        toggle(
                          "video",
                          i
                        )
                      }

                      sx={{
                        position:
                          "absolute",

                        top: 4,
                        left: 4,

                        zIndex: 5,

                        color:
                          "#fff",

                        bgcolor:
                          "rgba(0,0,0,0.45)",

                        borderRadius:
                          "50%",

                        p: 0.5,

                        "&.Mui-checked":
                        {
                          color:
                            "#fff",
                        },
                      }}
                    />

                    {/* DELETE */}
                    <IconButton
                      onClick={() =>
                        onRemoveVideo(
                          i
                        )
                      }

                      sx={{
                        position:
                          "absolute",

                        top: 4,
                        right: 4,

                        zIndex: 5,

                        color:
                          "#fff",

                        bgcolor:
                          "rgba(0,0,0,0.55)",

                        "&:hover":
                        {
                          bgcolor:
                            "rgba(0,0,0,0.75)",
                        },
                      }}
                    >
                      <DeleteIcon
                        fontSize="small"
                      />
                    </IconButton>

                    {/* VIDEO */}
                    <video
                      src={vid}
                      controls
                      style={{
                        width: "100%",
                        height: 180,
                        objectFit:
                          "cover",
                        display:
                          "block",
                      }}
                    />
                  </Box>
                </Grid>
              )
            )

          ) : (

            <Grid item xs={12}>
              <Typography
                variant="caption"
              >
                No videos
              </Typography>
            </Grid>
          )}
        </Grid>

      </DialogContent>

      {/* ================================================= */}
      {/* PROGRESS */}
      {/* ================================================= */}

      {uploading && (

        <Box
          sx={{
            px: 2,
            pb: 1,
          }}
        >

          <Typography
            variant="caption"
          >
            Uploading: {progress}%
          </Typography>

          <Box
            sx={{
              height: 6,

              bgcolor:
                "#ddd",

              borderRadius: 5,

              overflow:
                "hidden",

              mt: 0.5,
            }}
          >

            <Box
              sx={{
                width:
                  `${progress}%`,

                height:
                  "100%",

                bgcolor:
                  "primary.main",

                transition:
                  "width 0.3s",
              }}
            />
          </Box>
        </Box>
      )}

      {/* ================================================= */}
      {/* MESSAGE */}
      {/* ================================================= */}

      {message && (

        <Typography
          variant="caption"
          sx={{
            px: 2,
            pb: 1,

            color:
              message.includes(
                "❌"
              )
                ? "red"
                : "green",
          }}
        >
          {message}
        </Typography>
      )}

      {/* ================================================= */}
      {/* ACTIONS */}
      {/* ================================================= */}

      <DialogActions>

        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={uploading}
        >
          {uploading
            ? "Uploading..."
            : "Upload"}
        </Button>

        <Button
          onClick={() =>
            setOpen(false)
          }
        >
          Close
        </Button>

      </DialogActions>

    </Dialog>
  );
}